export const GOOGLE_COOKIES_ENABLED_LOCAL_STORAGE_KEY = "googleAdsConsent";